import React, { useState } from 'react';
import './FlipCardExample.css';

const FlipCardExample = ({ question, answer }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className={`flip-card ${flipped ? 'flipped' : ''}`} onClick={() => setFlipped(!flipped)}>
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <h4>Interview Question</h4>
          <p>{question}</p>
        </div>
        <div className="flip-card-back">
          <h4>Expert Answer</h4>
          <p>{answer}</p>
        </div>
      </div>
    </div>
  );
};

export default FlipCardExample;
